import styled from 'styled-components'
import { Link } from 'gatsby'
import { Brevier } from '~/components/Typography'
import { mediaqueries } from '../../utils/mediaqueries'

export const Header = styled.header`
  position: relative;
  z-index: 10;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme: { color, toRem } }) => `
    height: ${toRem(50)}
    background: ${color('light')}
    border-bottom: 1px solid ${color('accent', 90)}
    padding: 0 ${toRem(20)}; 
  `}

  @media ${mediaqueries.md} {
    height: 61px;
    ${({ theme: { toRem } }) => `
      padding: 0 ${toRem(30)};
      `} 
  }
`

export const Section = styled.section`
  display: flex;
  align-items: center;
  @media ${mediaqueries.md} {
    flex: 0 0 calc(100% / 3);
  }
`

export const Left = styled(Section)`
  h2 {
    @media ${mediaqueries.md} {
      min-width: 170px;
    }
  }
`

export const Center = styled(Section)`
  justify-content: center;
`

export const Right = styled(Section)`
  justify-content: flex-end;
`
export const MenuLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const ButtonLink = styled(MenuLink)`
  border-radius: 2px;
  margin-right: 10px;
  font-size: 13px !important;
  text-align: center;
 ${({ theme: { color, toRem } }) => `
    background: ${color('core')};
    color: ${color('light')};
    padding: ${toRem(8)} ${toRem(10)};
  `}

  @media ${mediaqueries.md} {
      margin-right: 20px;
      ${({ theme: { toRem } }) => `
        padding: ${toRem(12)} ${toRem(20)};
      `};
  }

`

export const LogoLink = styled.a`
  color: inherit;
  text-decoration: none;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  
  padding-right: 20px;


  svg {
    @media ${mediaqueries.max.md} {
      width: 100px !important;
      height: auto !important;
    }
  }
`

export const GeneralLink = styled.a`
  color: inherit;
  text-decoration: none;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  text-transform: uppercase;
  padding: 15px;
  font-size: 13px;

  font-weight: 500;
  letter-spacing: 0.08em;

  @media ${mediaqueries.max.sm} {
    display: none;
  }
`

export const ItemCount = styled.span`
  display: flex;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  position: absolute;
  top: -5px;
  right: -5px;

  ${({ theme: { setDimensions, toRem, color } }) => `
    ${setDimensions(toRem(15))}
    background: ${color('core')};
    color: ${color('light')};
  `}
`
export const Label = styled(Brevier)`
  font-size: 13px;
  line-height: 19px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.05em;
  margin-right: 11px;
`
